/** @module csi/view/ToolbarPluginToggleButton */
define([
	"dojo/_base/lang",
	"dijit/form/ToggleButton",
	"csi/_base/underscore",
	"csi/def/Action",
	"csi/def",
	"csi/view/PluginFactory",
	"./ToolbarPlugin"
], function(lang,ToggleButton,_,Action,def,PluginFactory,ToolbarPlugin) {

	return PluginFactory.declare("ToolbarToggleButton",[ToggleButton, ToolbarPlugin], {
		constructor: function() {
			// control type should be set here for the case when descendants (ToolbarPluginSuspend) call defAction.resolve from within constructor.
			this.defAction = lang.mixin(new Action(), {m_typeControl: def.ACTION_TOGGLE_BUTTON});
		},

		postMixInProperties: function() {
			// summary: set appearance based on action

			// Control type should be re-set here for the case when descendants re-create action
			this.defAction.m_typeControl = def.ACTION_TOGGLE_BUTTON;

			this._mixinActionProperties();
			this["class"] = 'csi-button-switch';
			this.inherited(arguments);
		},

		enablePlugin: function(/*Context?*/ctx) {
			// summary: if toggled state can be detected from context, then use it to update toggled state
			this.inherited(arguments);

			// need to re-apply context to get current toggled state
			if (ctx) {
				var toggled = this.isToggledInitially(ctx);
				if (toggled !== null) {
					// change to toggled state should not invoke action
					this.set("checked", toggled, false);
				}
			}
		},

		/**
		 * Do not instantiate buttons when printing
		 */
		validatePlugin: function(ctx) {
			return !ctx.bPrint;
		},

		_setCheckedAttr: function(/*Boolean*/value) {
			// summary: update checked status of radio button along with toggled name
			var a = this.defAction;
			value = !!value;
			this.set("label", _.escape(value ? (a.m_nameToggle || a.m_name) : a.m_name));
			this.inherited(arguments);
		},

		onChange: function(/*Object*/value, /*Action*/action) {
			// summary: invoke action for change - negate value for toggle since it represents
			// checked value before action is applied
			// NOTE: for some reason, Dojo triggers onChange event when button is disabled, so
			// make sure to check for that here
			var self = this;
			if (!this.get("disabled")) {
				_.delay(function(){
					self._invokeAction(action || self.defAction, null, {
						actionValue: value,
						m_bToggle: !value
					});
				}, 200); // we need 200ms for switch button animation to complete;
			}
		},

		onClick: function(/*Event*/e) {
			// summary: ignore this event in favor of onChange
			e.stopPropagation();
			return true;
		}
	});
});